<!-- منبع : -->
<!-- https://www.digitalocean.com/community/tutorials/vuejs-vue-chart-js -->
<!-- https://www.chartjs.org/docs/latest/ -->

<template>
  <div class="text-center">
    <canvas style="position: relative; height:265px; width:95%; margin: 0px auto; padding-top: 10px;" v-bind:id="'planet-chart-' + ChartID"></canvas>
  </div>
</template>

<script>
import Chart from 'Chart.js'

export default {
  name: 'PlanetChart',
  props: ['ChartData','ChartID'],
  data() {
      return {
          planetChartData: this.ChartData,
      }
  },
  mounted() {
    const ctx = document.getElementById('planet-chart-' + this.ChartID);
    // Chart.defaults.font.family = "VazirFD";
    new Chart(ctx, this.planetChartData);
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/Dashboard/ChartComponents/PlanetChart.vue